import { render } from "./CropOrganicFertilizationForm.vue?vue&type=template&id=6ee6e60b&scoped=true&ts=true"
import script from "./CropOrganicFertilizationForm.vue?vue&type=script&lang=ts"
export * from "./CropOrganicFertilizationForm.vue?vue&type=script&lang=ts"

import "./CropOrganicFertilizationForm.vue?vue&type=style&index=0&id=6ee6e60b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee6e60b"]])

export default __exports__